import { Card, CardContent, CardMedia } from "@material-ui/core";
import marked from "marked";
import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import { ReactComponent as PlayIcon } from "../../../assets/img/icons/bigPlayIcon.svg";
import { ReactComponent as LockIcon } from "../../../assets/img/icons/lock.svg";
import { Link } from "react-router-dom";
import "./ProgrammeCard.scss";
import classNames from "classnames";

const MarkedDownContent = ({ content }) => {
  return <div dangerouslySetInnerHTML={{ __html: marked(content) }}></div>;
};

interface Props {
  primaryButtonUrl: any;
  primaryButtonText: string;
  secondaryButtonUrl: string;
  programmeTitle: string;
  cardTitle: any;
  imgUrl: any;
  imgTitle: any;
  description: any;
  isLocked: any;
  enablePlayIcon: boolean;
  disableViewPathButton: boolean;
}

const ProgrammeCard: React.FC<Props> = ({
  primaryButtonUrl,
  primaryButtonText,
  secondaryButtonUrl,
  programmeTitle,
  cardTitle,
  imgUrl,
  imgTitle,
  description,
  isLocked,
  enablePlayIcon,
  disableViewPathButton = false,
}: Props) => {
  return (
    <Card
      className={`programme-card__container ${isLocked && "locked"}`}
      elevation={0}
    >
      <div>
        <Link
          to={primaryButtonUrl}
          className="programme-card__container-link"
          aria-label="Programme Card"
          id={"currentStepCardTextWrapper"}
        >
          <div className={`programme-card__header`}>
            <h2 className={`programme-card__header--subtitle`}>
              {programmeTitle}
            </h2>
            <h3 className={"programme-card__header--title"}>{cardTitle}</h3>
          </div>
        </Link>
      </div>
      <div className="programme-card__main-content">
        <Link
          to={primaryButtonUrl}
          className="programme-card__container-link"
          aria-label="Video Thumbnail"
          id={"currentStepCardContentWrapper"}
        >
          <CardMedia
            className={`video__image-container`}
            image={imgUrl}
            title={imgTitle}
          >
            <div className={classNames({ overlay: enablePlayIcon })}>
              <div className="play-lock-icon__container">
                <span className="icon" key="programme-card__play-icon">
                  {!isLocked && enablePlayIcon && <PlayIcon />}
                  {isLocked && <LockIcon />}
                </span>
              </div>
            </div>
          </CardMedia>
          <CardContent className={`programme-card__content-container`}>
            <MarkedDownContent content={description} />
          </CardContent>
        </Link>
      </div>
      <div>
        <CardContent
          id="programme-card__buttons"
          className={`programme-card__buttons`}
        >
          <Link
            to={primaryButtonUrl}
            className="programme-card__container-link"
            aria-label="Current Step"
            id={"lets-get-started-button"}
          >
            <Button
              className="programme-card__button"
              tabIndex="-1"
              color="primary"
            >
              {primaryButtonText}
            </Button>
          </Link>
          {!disableViewPathButton && (
            <Link
              to={secondaryButtonUrl}
              className="programme-card__container-link secondary"
              aria-label="Current Step"
              id={"my-path-button"}
            >
              {`View ${programmeTitle} Path`}
            </Link>
          )}
        </CardContent>
      </div>
    </Card>
  );
};

export default ProgrammeCard;
